import { baseApi } from 'shared/api'

export const leveragesApi = baseApi.injectEndpoints({
  endpoints: build => ({
    leverages: build.query<any, void>({
      query: () => ({
        url: `leverages`,
      }),
    }),
  }),
})

export const { useLeveragesQuery } = leveragesApi
